/*
 * @Author: wblijinyang
 * @FilePath: /mall-fe/src/views/web/product/conponents/ProductFormDeatil/ProductDetailMmuBody.tsx
 * @Description:
 */
import { useMemo, useState, useContext, useEffect, useCallback, Fragment } from 'react';
import { UserContext, PriceContext } from 'libs/contexts';
import { getFirstTownOfCityCode, getUserDetail } from 'api/user';
import InputNumberComp from '@/comps/InputNumber';
import ProductDetailAttribute from './ProductDetailAttribute';
import ProductDetailMmuFooter from './ProductDetailMmuFooter';
import AreaCascader from 'comps/AreaCascader';
import useAreaCookie from 'hooks/useAreaCookie';
import {
  useNetPriceTypeContext,
  useProductDetailContext,
  useShopDataContext,
  useTradeAgreementContext,
} from 'views/web/product/context';
import { Modal, message } from 'antd';
import useToLogin from '@/hooks/useToLogin';
import { addOrderTradeEnquire, displayEnquireButton } from 'api/enquiry';
import { useRouter } from 'next/router';
import useAddEnquiry from '@/hooks/useAddEnquiry';
import { getWofengServiceParams, isArray } from 'libs/utils';
import { amI } from '@/libs/user';
import IsExternalPurchaserUsed from '@/views/h5/my-center/shared/hooks/useIsExternalPurchaserUsed';
import SelfOperatedOrganization from '@/views/h5/my-center/features/settlement/hooks/useSelfOperatedOrganization';
import ProductDetailAttributeWithTag from './ProductDetailAttributeWithTag';
import type { IProductDetail } from '../../product';
import { getWofengService } from 'api/common';
const ProductDetailMmuBody = ({
  skuDetail,
  agreeAndUserTypeIsAvailable,
  shopId,
}: {
  skuDetail: IProductDetail;
  agreeAndUserTypeIsAvailable: boolean;
  shopId: string;
}) => {
  const userInfo = useContext(UserContext);
  const priceData = useContext(PriceContext);
  const { showSellCount } = priceData;
  const { handleLogin } = useToLogin();
  const { getProductDetail } = useProductDetailContext();
  const { selectNetPriceType } = useNetPriceTypeContext();
  const [shopQuantity, setShopQuantity] = useState(1);
  const { areaSysNo, setCookie, AREA_CODE_KEY, AREA_SYS_NO_KEY } = useAreaCookie();
  const { selectTradeAgreement } = useTradeAgreementContext();
  const [canShowEnquiryBtn, setCanShowEnquiryBtn] = useState(false);
  const { shop } = useShopDataContext();
  const route = useRouter();
  const { addEnquiryListStorage, getEnquiryListStorage } = useAddEnquiry();
  const isSupplier = amI(userInfo, 'supplier');
  const selfOperatedOrganization = SelfOperatedOrganization();
  const canShowEnquiry = !selfOperatedOrganization && (IsExternalPurchaserUsed() || isSupplier);
  async function handleAreaChange(data: string[]) {
    if (!data || !data?.length) return;
    // 根据市 查询最后一级地区信息
    let res = await getFirstTownOfCityCode(data[data.length - 1]);
    if (res?.code === 200 && res?.data) {
      const { levelCode } = res.data;

      // 更新地区相关的状态和搜索参数
      setCookie(AREA_SYS_NO_KEY, res.data.sysNo);
      setCookie(AREA_CODE_KEY, levelCode);
      getProductDetail({}, true);
    }
  }

  const reasonsForBlockingTrans = useMemo(() => {
    // 已登录且选中的交易规则导致不可售
    if (!agreeAndUserTypeIsAvailable && userInfo) {
      return {
        show: true,
        // message: '该商品暂不支持销售，点此联系卖家',
        message: '该商品暂不支持销售',
      };
    }
    // 当前选中的地区导致不可售
    else if (skuDetail.sysNo && !skuDetail.areaCanSale) {
      return {
        show: true,
        // message: '该地区暂不支持销售，点此联系卖家',
        message: '该地区暂不支持销售',
      };
    } else {
      return {
        show: false,
        message: null,
      };
    }
  }, [skuDetail, userInfo, agreeAndUserTypeIsAvailable]);

  // 商品关键属性发生变更，商品 sysNo 发生变更，重新请求
  const handleChangeSku = (data) => {
    getProductDetail(
      {
        sysNo: data,
        netPriceType: selectNetPriceType,
      },
      true,
    );
  };

  // 非关键属性发生变更，重新请求ProductDetail
  const handleChangeMmu = () => {
    const { mmuAttributeTagList } = skuDetail;
    // 将 mmuAttributeTagList 展开，形成 mmuAttributeList
    const mmuAttributeList = mmuAttributeTagList.flatMap(
      (mmuTagList) => mmuTagList.mmuAttributeList,
    );
    getProductDetail({
      mmuAttributeList,
      netPriceType: selectNetPriceType,
    });
  };

  // 游客-客服咨询
  const visitorToService = async () => {
    const tranfetData = {
      profile: null,
      applications: [],
      supplierSysNo: shop?.supplierSysNo || skuDetail?.supplierSysNo,
    };
    const params = await getWofengServiceParams(tranfetData);
    const res = await getWofengService(params);
    if (res.code === 200) {
      window.open(res.data?.h5?.url, '_blank');
    }
  };

  const seekHelp = async () => {
    if (userInfo?.name) {
      const { data } = await getUserDetail();
      const tranfetData = {
        profile: data.profile,
        applications: data.applications,
        supplierSysNo: shop?.supplierSysNo || skuDetail?.supplierSysNo,
      };
      const params = await getWofengServiceParams(tranfetData);
      const res = await getWofengService(params);
      if (res.code === 200) {
        window.open(res.data?.h5?.url, '_blank');
      }
      return;
    } else {
      Modal.confirm({
        title: '提示框',
        content: '您当前尚未登录，请先登录或以访客身份咨询客服。',
        okText: '去登录',
        cancelText: '访客咨询',
        onOk: function () {
          handleLogin();
        },
        onCancel: function () {
          // 游客身份访问
          visitorToService();
        },
      });
    }
  };

  const handleEnquiry = async () => {
    try {
      const id = route?.query?.id as string;
      const data = {
        quantity: shopQuantity,
        skuSysNo: skuDetail?.sysNo || id,
      };

      if (!userInfo) {
        const enquiryList = getEnquiryListStorage();
        if (isArray(enquiryList)) {
          const enquiryData = enquiryList.find((item) => item.skuSysNo === data.skuSysNo);
          if (enquiryData) {
            enquiryData.quantity += shopQuantity;
          } else {
            enquiryList.push(data);
          }
          addEnquiryListStorage(enquiryList);
        } else {
          addEnquiryListStorage([data]);
        }
      } else {
        const params = {
          ...data,
          userSysNo: userInfo?.sysNo,
        };

        const res = await addOrderTradeEnquire(params);
        if (res?.code !== 200) return;
      }

      message.success('加入成功');
    } catch (error) {}
  };
  // 是否展示询价按钮
  const searchEnquiryBtn = useCallback(async () => {
    try {
      const supplierSysNo = skuDetail.supplierSysNo || shop?.supplierSysNo;
      if (!supplierSysNo) {
        setCanShowEnquiryBtn(false);
        return;
      }
      if (!canShowEnquiry && !!userInfo?.sysNo) {
        setCanShowEnquiryBtn(false);
        return;
      }
      const res = await displayEnquireButton(supplierSysNo);
      setCanShowEnquiryBtn(!!res?.data);
    } catch (error) {}
  }, [skuDetail.supplierSysNo, shop?.supplierSysNo, canShowEnquiry, userInfo?.sysNo]);

  useEffect(() => {
    searchEnquiryBtn();
  }, [searchEnquiryBtn]);

  return (
    <>
      <div className="pd-bd">
        <div className="product-filter J_ProductSelector">
          {/* 关键商品属性 */}
          {skuDetail.attributeList?.map((attribute) => (
            <div className="product-filter-type" key={attribute.attributeSysNo}>
              <div className="product-filter-title" title={attribute.attributeName}>
                {attribute.attributeName}
              </div>
              <div className="product-filter-item-wrap">
                <ProductDetailAttribute
                  attributeData={attribute}
                  isMmu={false}
                  handleChangeSku={handleChangeSku}
                />
              </div>
            </div>
          ))}
          {/* 非关键商品属性 mmu 渲染逻辑：有标签名 & 无标签名 */}
          {/* 非关键商品属性 mmu 具备「标签」聚合功能 */}
          {/* {skuDetail.mmuAttributeList
            ?.filter((item) => item.attributeTag)
            .map((mmuAttribute, index) => (
              <Fragment key={mmuAttribute.attributeSysNo}>
                <div className="product-filter-title-tag">
                  {index === 0 ? mmuAttribute.attributeTag : ''}
                </div>
                <div className="product-filter-type">
                  <div
                    className="product-filter-item-wrap_special_left"
                    title={mmuAttribute.attributeName}
                  >
                    {mmuAttribute.attributeName}
                  </div>
                  <div className="product-filter-item-wrap_special_right">
                    <ProductDetailAttribute
                      attributeData={mmuAttribute}
                      isMmu={true}
                      handleChangeMmu={handleChangeMmu}
                    />
                    {mmuAttribute.attributeName === '区域属性' && (
                      <Tooltip
                        overlayInnerStyle={{ width: '400px' }}
                        title={
                          <div>
                            <div>泵类的标号仅供深圳、南京等区域项目选择，其他区域勿选；</div>
                            <div>选择区域属性后，系统将自动拼接强度等级与区域属性推送至云砼；</div>
                            <div>
                              例：强度等级选择【C30】，区域属性选择【泵】，推送时为【C30泵】
                            </div>
                          </div>
                        }
                      >
                        <span className="question-icon">
                          <QuestionCircleOutlined />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </Fragment>
            ))}
          {skuDetail.mmuAttributeList
            ?.filter((item) => !item.attributeTag)
            .map((mmuAttribute) => (
              <div className="product-filter-type" key={mmuAttribute.attributeSysNo}>
                <div className="product-filter-title" title={mmuAttribute.attributeName}>
                  {mmuAttribute.attributeName}
                </div>
                <div className="product-filter-item-wrap">
                  <ProductDetailAttribute
                    attributeData={mmuAttribute}
                    isMmu={true}
                    handleChangeMmu={handleChangeMmu}
                  />
                  {mmuAttribute.attributeName === '区域属性' && (
                    <Tooltip
                      overlayInnerStyle={{ width: '400px' }}
                      title={
                        <div>
                          <div>泵类的标号仅供深圳、南京等区域项目选择，其他区域勿选；</div>
                          <div>选择区域属性后，系统将自动拼接强度等级与区域属性推送至云砼；</div>
                          <div>例：强度等级选择【C30】，区域属性选择【泵】，推送时为【C30泵】</div>
                        </div>
                      }
                    >
                      <span className="question-icon">
                        <QuestionCircleOutlined />
                      </span>
                    </Tooltip>
                  )}
                </div>
              </div>
            ))} */}
          {skuDetail.mmuAttributeTagList?.map((mmuListWithTag, index) => {
            return (
              <ProductDetailAttributeWithTag
                mmuAttributeListWithTag={mmuListWithTag}
                onMmuChange={handleChangeMmu}
                key={index}
              />
            );
          })}
        </div>
        {!!skuDetail.upstreamSupplierName && (
          <div className="pd-addr">
            <div className="pd-l-auto">配送商</div>
            <div className="pd-r  pd-r-content">{skuDetail.upstreamSupplierName}</div>
          </div>
        )}
        {!!skuDetail.upstreamSupplierName && !!skuDetail.deliveryName && (
          <div className="pd-addr">
            <div className="pd-l-auto">配送商联系人</div>
            <div className="pd-r  pd-r-content">
              {skuDetail.deliveryName} {skuDetail.deliveryPhone}{' '}
            </div>
          </div>
        )}

        <div className="pd-addr">
          <div className="pd-l">配送至</div>
          <div className="pd-r pd-r-content">
            <div className="mmu-address-selector-wrap">
              <AreaCascader
                placeholder="请选择"
                value={areaSysNo}
                areaLevel={3}
                separator={''}
                onChange={(data) => handleAreaChange(data)}
                trigger="click"
                skuSysNo={skuDetail.sysNo}
                agreementSysNo={selectTradeAgreement.parentSysNo}
              />
              {/* {showSellCount && skuDetail.freightTemplateMemo && (
                <span style={{ marginLeft: '5px' }}>{skuDetail.freightTemplateMemo}</span>
              )} */}
              {!!skuDetail.freightTemplateMemo && (
                <span style={{ marginLeft: '5px' }}>{skuDetail.freightTemplateMemo}</span>
              )}
              {!!reasonsForBlockingTrans.show && (
                <div className="cascader-tip">{reasonsForBlockingTrans.message}</div>
              )}
            </div>
          </div>
        </div>

        <div className="pd-num pd-addr">
          <div className="pd-l">采购数量</div>
          <div className="pd-r pd-r-content">
            <div className="pd-num-input">
              <InputNumberComp
                value={shopQuantity}
                onChange={(value) => {
                  setShopQuantity(value);
                }}
                max={!!skuDetail.inventory ? skuDetail.inventory : 99999999}
                disabled={skuDetail.inventory === 0}
                step={skuDetail.buyStep || 1}
              />
              {skuDetail.inventory !== undefined &&
                skuDetail.showInventory &&
                (!!skuDetail.inventory ? (
                  <span className="inventory-info">
                    {skuDetail.inventory}
                    {skuDetail.unitName}可售
                  </span>
                ) : skuDetail.inventory == null ? (
                  <span className="inventory-info">有货</span>
                ) : (
                  <div className="cascader-tip">无货，此商品暂时售完</div>
                ))}
            </div>
          </div>
        </div>
        <style jsx>{`
        .product-filter {
            margin-top: 20px;
        }
        .product-filter-type {
            display: flex;
        }
        .product-filter .product-filter-type .product-filter-title {
            padding: 6px 10px 0 20px;
            color: #999;
            max-width: 110px;
            width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: normal;
            white-space: nowrap;
        }
        .product-filter-title-tag {
          padding: 6px 10px 10px 20px;
          // color: #999;
        }
        .product-filter .product-filter-type .product-filter-item-wrap_special_left {
            padding: 6px 10px 0 20px;
            color: #999;
            max-width: 110px;
            width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: normal;
            white-space: nowrap;
        }
        .product-filter .product-filter-type .product-filter-item-wrap_special_right {
            display: flex;
            float: left;
            width: 520px;
            margin-bottom: 10px;
        }
        .product-filter .product-filter-type .product-filter-item-wrap {
            display: flex;
            float: left;
            width: 630px;
            margin-bottom: 10px;
        }
        .question-icon {
          margin-top: 5px;
        }
        .pd-addr {
            margin-bottom: 20px;
            display: flex;
        }
        .pd-l {
            line-height: 28px;
            display: inline-block;
            font-size: 12px;
            width: 50px;
            margin-right: 40px;
            color: #999;
            margin-left: 20px;
        }
        .pd-l-auto {
          height: 28px;
          display: inline-block;
          width: fit-content !important;
          margin-right: 45px;
          color: #999;
          align:left;
          margin-left: 20px;
          flex: none;

      }
        .pd-r-content {
            vertical-align: top;
        }
        .pd-addr .cascader-tip {
            display: inline-block;
            vertical-align: middle;
            margin-left: 12px;
            position: relative;
            background: #f76149;
            border-radius: 2px;
            -moz-border-radius: 2px;
            -webkit-border-radius: 2px;
            height: 28px;
            line-height: 28px;
            padding: 0 12px;
            color: #fff;
            font-size: 14px;
            text-align: center;
        }
        .cascader-tip:before {
            position: absolute;
            content: "";
            border-right: 6px solid #f76149;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            left: -6px;
            top: 9px;
        }
        .pd-num-input {
            display: flex;
            vertical-align: top;
        }
        :global(.ant-input-number-group-wrapper) {
          width: 130px;
        }
        .product-filter-type .product-filter-item-wrap {
          width: 630px;
          margin-bottom: 10px;
        }
        .mmu-address-selector-wrap {
          display: flex;
        }
        .mmu-address-selector-wrap :global(.cascader) {
          position: relative;
          display: inline-block;
          min-width: 150px;
          border: 1px solid #e8e8e8;
          vertical-align: middle;
          line-height: 28px;
          padding-left: 8px;
          font-size: 12px;
          padding-right: 5px;
        }
        .inventory-info {
          margin-left: 10px;
          font-size: 12px;
          display: inline-block;
          height: 28px;
          line-height: 28px;
          color: #666;
        }
      `}</style>
      </div>
      {!userInfo || userInfo.isPurchaser ? (
        <ProductDetailMmuFooter
          shopId={shopId}
          shopQuantity={shopQuantity}
          skuDetail={skuDetail}
          agreeAndUserTypeIsAvailable={agreeAndUserTypeIsAvailable}
          canShowEnquiryBtn={canShowEnquiryBtn}
          handleEnquiry={handleEnquiry}
        />
      ) : (
        !!canShowEnquiryBtn && (
          <div>
            <div className="enquiry" onClick={handleEnquiry}>
              加入询价单
            </div>
            <style jsx>{`
            .enquiry {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 180px;
              height: 48px;
              font-size: 16px!important;
              font-weight: 400;
              color: #fff;
              background-color: var(--rv-primary-color);
              border: 1px solid var(--rv-primary-color);
              border-radius: 8px;
              cursor: pointer;
            }
        `}</style>
          </div>
        )
      )}
    </>
  );
};
export default ProductDetailMmuBody;
